import { Divider, Grid, Typography } from '@material-ui/core';
import { GrupoAcesso } from 'common/genericTypes';
import { CpfCnpjMask } from 'components/masks';
import { Button, MdSpace, TextField } from 'm2m.components';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from 'store';
import { updateField } from 'store/modules/participantes/registro';
import { sanitizeAlphanumericCnpj } from 'utils/cnpjUtils';
import { validaCpfCnpj, stripCpfCnpjFormatting } from 'utils/validation';

interface Props {
  onSubmit: () => void;
}

const ValidacaoCnpj: React.FC<Props> = (props) => {
  const { onSubmit } = props;
  const dispatch = useDispatch();

  const isUsuarioLaqus = useSelector(
    (state: RootState) =>
      state.auth?.usuario?.grupoAcesso === GrupoAcesso.Operacoes ||
      state.auth?.usuario?.grupoAcesso === GrupoAcesso.CadastroOperacoes
  );
  const participante = useSelector((state: RootState) => state.participante);
  const getHasCnpj = useSelector((state: RootState) => state.participanteApi.getHasCnpj);

  const [cnpjParticipante, setCnpjParticipante] = useState<string>();
  const [isCnpjUnique, setIsCnpjUnique] = useState<boolean>(true);
  const [isCnpjValid, setIsCnpjValid] = useState<boolean>(false);
  const [loading, setLoading] = useState<boolean>(false);
  const [error, setError] = useState<boolean>(false);

  const handleCnpjChange = (value: string) => {
    value = sanitizeAlphanumericCnpj(value);
    if (value.length > 14) {
      return;
    }
    setError(false);
    setIsCnpjUnique(true);
    setIsCnpjValid(false);
    if (value.length === 14) {
      setIsCnpjValid(validaCpfCnpj(value));
      if (isUsuarioLaqus) {
        setLoading(true);
        getHasCnpj(dispatch, value)
          .then((hasCnpj) => {
            setIsCnpjUnique(!hasCnpj);
          })
          .catch(() => setError(true))
          .finally(() => setLoading(false));
      }
    }
    setCnpjParticipante(value);
  };

  const handleSubmit = () => {
    dispatch(updateField({ name: 'cnpjParticipante', value: cnpjParticipante! }));
    onSubmit();
  };

  useEffect(() => {
    setError(cnpjParticipante?.length === 14 && (!isCnpjUnique || !isCnpjValid));
  }, [cnpjParticipante, isCnpjUnique, isCnpjValid]);

  return (
    <>
      <Grid container justify="center">
        <Grid item sm={12}>
          <Divider variant="fullWidth" />
          <MdSpace />
        </Grid>
        <Grid item sm={4}>
          <Typography variant="h3" align="center">
            {'Antes de começar, nos informe o CNPJ a ser cadastrado:'}
          </Typography>
          <MdSpace />
          <TextField
            label="CNPJ Participante"
            value={CpfCnpjMask(cnpjParticipante ?? '')}
            onChange={handleCnpjChange}
            error={error}
            errorMessage={(!isCnpjValid && 'CNPJ inválido') || (!isCnpjUnique && 'CNPJ já cadastrado') || undefined}
          />
          <MdSpace />
        </Grid>
      </Grid>
      <Grid container justify="center">
        <Grid item>
          <Button
            variant="contained"
            color="primary"
            onClick={handleSubmit}
            disabled={cnpjParticipante?.length !== 14 || !isCnpjUnique || !isCnpjValid || loading || error}
          >
            {'Prosseguir'}
          </Button>
          <MdSpace />
        </Grid>
      </Grid>
    </>
  );
};

export default ValidacaoCnpj;
